import { createSlice } from "@reduxjs/toolkit";
import { fetchPatchVdaAction } from "./actions";
import { DataStatus } from "../../types";

type VdaActionsState = {
  data: Array<any>; // You may want to define a proper VdaAction type
  status: DataStatus;
  error: string | null;
};

const initialState: VdaActionsState = {
  data: [],
  status: DataStatus.idle,
  error: null,
};

export const Slice = createSlice({
  name: "vdaActions",
  initialState,
  reducers: {
    resetVdaActions: () => initialState,
    setVdaActions: (state, action) => {
      state.data = action.payload;
    },
    addVdaAction: (state, action) => {
      state.data = [action.payload, ...state.data];
      return state;
    },
    updateVdaAction: (state, action) => {
      state.data = state.data.map((vdaAction) =>
        vdaAction.id === action.payload.id
          ? { ...vdaAction, ...action.payload }
          : vdaAction
      );
      return state;
    },
    removeVdaAction: (state, action) => {
      state.data = state.data.filter(
        (vdaAction) => vdaAction.id !== action.payload
      );
      return state;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPatchVdaAction.pending, (state) => {
        state.status = DataStatus.loading;
        state.error = null;
      })
      .addCase(fetchPatchVdaAction.fulfilled, (state) => {
        state.status = DataStatus.succeeded;
      })
      .addCase(fetchPatchVdaAction.rejected, (state, action) => {
        state.status = DataStatus.failed;
        state.error = action.error.message ?? "";
      });
  },
});

export default Slice;
